import React from 'react';
import { Box } from '@styleseat/ui';
import TopBarNavigation from '../../provider/navigation/TopBarNavigation/TopBarNavigation';
import { NAV_BAR_HEIGHT } from '../../shared/BottomNavBar/BottomNavBar';
import Footer from '../../shared/Footer';
import { Absolute } from '../../ui';
import { useIsMobile } from '../../../hooks';
import ProNavBarContainer, { TabOption } from '../../provider/tabs/ProNavBarContainer';
import { Z_NAVIGATION } from '../../ui/utilities/zIndex';

type ProviderLayoutProps = {
  children: React.ReactNode;
  providerId: number;
  highlightedTab?: TabOption;
  renderMobileHeader?: () => React.ReactNode;
  showFooter?: boolean;
  showMobileNavBar?: boolean;
};

export const ProviderLayout: React.FC<ProviderLayoutProps> = ({
  children,
  providerId,
  highlightedTab,
  showFooter,
  renderMobileHeader,
  showMobileNavBar = true,
}) => {
  const isMobile = useIsMobile();
  // footer has a CSS style that restricts it from showing on mobile,
  //  so we are duplicating that here for clarity
  const willShowFooter = !isMobile && showFooter;
  return (
    <Absolute
      flexShrink={1}
      flexGrow={1}
      all={0}
    >
      <Box flexGrow={0} flexShrink={0} zIndex={Z_NAVIGATION}>
        {isMobile
          ? renderMobileHeader?.()
          : (
            <TopBarNavigation providerId={providerId} />
          )}
      </Box>

      <Box flexGrow={1} flexShrink={willShowFooter ? 0 : 1}>
        {children}
      </Box>

      {willShowFooter ? <Footer /> : null}
      {(isMobile && showMobileNavBar) ? (
        <Box
          flexGrow={0}
          flexShrink={0}
          style={{ height: NAV_BAR_HEIGHT }}
        >
          <ProNavBarContainer tab={highlightedTab} />
        </Box>
      ) : null}
    </Absolute>
  );
};
